export const CHART_OPTION_MAP = [15, 30];
export const CHART_OPTION_TYPE_MAP = ['现金', '云豆'];
export const DISTRIBUTION_MAP = {
  1: {
    name: '贡献收益',
    ename: 'contribution',
  },
  2: {
    name: '邀请奖励',
    ename: 'invite',
  },
  3: {
    name: 'x86代理',
    ename: 'x86',
  },
  4: {
    name: '在线奖励',
    ename: 'online',
  },
  5: {
    name: '活动奖励',
    ename: 'other',
  },
};

export const DEFAULT_PAGE = 0;
export const DEFAULT_INCOME_PAGE_SIZE = 20;
export const DEFAULT_GROUP_ITEM = {
  gid: -1,
  gname: '全部',
};

export const ACTIVITY_AWARD_MAP = {
  10001: '运营商奖励',
  10003: '财神爷活动奖励',
  21001: '定向B业务25%活动奖励',
  30001: '活动奖励',
  21002: 'T业务月度质量奖(5月)',
  21003: 'S业务月度质量奖(5月)',
  21004: 'B业务月度质量奖(5月)',
};

export const MODAL_CONTENT = {
  contribution: {
    button: '知道了',
    content: '<p>展示您当前账户下所有设备赚取的贡献收益，不包含活动、加成卡等其他奖励。</p>',
    title: '贡献收益说明',
  },
  invite: {
    button: '知道了',
    content:
      '<p>参与当前及历史邀请活动所获得的红包、加成等奖励。可前往【我的】-【邀请好友】中查看奖励明细。</p>',
    title: '邀请奖励说明',
  },
  other: {
    button: '知道了',
    content:
      '<p>包含以下形式奖励：</p><p>1、运营商奖励</p><p>2、加成卡加成奖励</p><p>3、X86加机活动的奖励</p><p>4、其他奖励</p>',
    title: '其他活动说明',
  },
  cloudBean: {
    button: '知道了',
    content: '<p>通过云豆在商城中兑换成功且到账的现金总额</p>',
    title: '云豆兑现金',
  },
  cloudBeanDay: {
    title: '云豆兑现金',
    button: '知道了',
    content: '<p>当日通过云豆在商城中兑换成功且到账的现金总额</p>',
  },
};

// 收益广告跳转链接拼接前缀
export const LINK_PREFIX_MAP = {
  // H5链接APP内打开
  0: 'page:web_view?url=',
  // H5链接APP外打开
  1: 'intent:',
  // 原生链接
  2: 'android:',
};
